import React from 'react'

function EntryModal({ isVisible, onEnter }) {
  if (!isVisible) return null

  const handleButtonClick = () => {
    // Play the audio
    const audio = new Audio('/sound/raresttune.mp3')
    audio.volume = 0.5 // Set volume to 50%
    audio.loop = true // Loop the music
    audio.play().catch(error => {
      console.log('Audio playback failed:', error)
    })
    
    // Close the modal
    onEnter()
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 1)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(5px)'
    }}>
      <div style={{
        textAlign: 'center',
        color: '#fff',
        padding: '40px',
        borderRadius: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: '400px',
        width: '90%'
      }}>
        {/* Question */}
        <h2 style={{
          fontSize: '2rem',
          fontWeight: 900,
          margin: '0 0 30px 0',
          color: 'rgb(255, 237, 253)',
          textShadow: 'rgba(0, 0, 0, 0.5) 2px 2px 4px',
          fontStyle: 'italic'
        }}>
          Enter cult?
        </h2>
        
        {/* Buttons */}
        <div style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handleButtonClick}
            style={{
              padding: '12px 30px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              color: '#fff',
              backgroundColor: 'transparent',
              border: '2px solid rgb(255, 237, 253)',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              minWidth: '80px'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgb(255, 237, 253)'
              e.target.style.color = '#000'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent'
              e.target.style.color = '#fff'
            }}
          >
            Yes
          </button>
          
          <button
            onClick={handleButtonClick}
            style={{
              padding: '12px 30px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              color: '#fff',
              backgroundColor: 'transparent',
              border: '2px solid rgba(255, 255, 255, 0.5)',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              minWidth: '80px'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent'
            }}
          >
            No
          </button>
        </div>
      </div>
    </div>
  )
}

export default EntryModal
